import { Cart } from '@medusajs/medusa'
import axios from '@/core/axios'
import { ValidateDiscountCodeDto, RemoveDiscountCodeDto } from '../dtos/discount.dto'

type ValidateDiscountResponse = {
    metadata: {
        valid: boolean
        message: string
        discount?: {
            id: string
            code: string
            rule: {
                type: 'percentage' | 'fixed' | 'free_shipping'
                value: number
                allocation: 'total' | 'item'
            }
        }
        cart?: Cart
    }
}

type RemoveDiscountResponse = {
    metadata: {
        cart: Cart
    }
}

export class DiscountRepository {
    public async validateAndApply(
        dto: ValidateDiscountCodeDto,
    ): Promise<ValidateDiscountResponse['metadata']> {
        const { data } = await axios.post<ValidateDiscountResponse>(
            '/discounts/validate',
            dto,
        )
        return data.metadata
    }

    public async remove(
        dto: RemoveDiscountCodeDto,
    ): Promise<Cart> {
        const { data } = await axios.delete<RemoveDiscountResponse>(
            `/discounts/${dto.cart_id}/${dto.code}`,
        )
        return data.metadata.cart
    }
}
